import createIsDirty from './selectors/isDirty';
import plain from './structure/plain';

export default createIsDirty(plain);


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/isDirty.js
// module id = 2062
// module chunks = 0